<template>
  <button
    type="button"
    class="relative inline-flex items-center justify-center flex-shrink-0 w-10 h-5 rounded-full cursor-pointer group focus:outline-none"
    role="switch"
    aria-checked="false"
    @click="enabled = !enabled">
    <span class="sr-only">Use setting</span>
    <span
      aria-hidden="true"
      class="absolute w-full h-full bg-white rounded-md pointer-events-none"></span>
    <span
      aria-hidden="true"
      :class="[
        enabled ? 'bg-theme-200' : 'bg-gray-200',
        'pointer-events-none absolute mx-auto h-3 w-9 rounded-full transition-colors duration-200 ease-in-out',
      ]"></span>
    <span
      aria-hidden="true"
      :class="[
        enabled ? 'translate-x-5 bg-theme-600' : 'translate-x-0 bg-gray-600',
        'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200  shadow ring-0 transition-transform duration-200 ease-in-out',
      ]"></span>
  </button>
</template>

<script setup lang="ts">
const enabled = defineModel<boolean>();
</script>
